import Link from 'next/link';
import React from 'react';

import { LogoScrollFragmentFragment } from '../../__generated__/graphql';
import AppImage from '../../components/AppImage';
import { Heading3 } from '../../components/Text';
import { ContentBlock } from '../types';

import style from './logo-scroll.module.css';

const logoCount = '--logo-count';
const logoHeight = '--logo-height';
const logoWidth = '--logo-width';

const defaultLogoHeight = 70;
const defaultLogoWidth = 200;

const LogoScroll: ContentBlock<LogoScrollFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.logoScroll;

  React.useEffect(() => {
    const logoScrollContainer = document.querySelector(`.${style.logoScrollContainer}`);
    if (logoScrollContainer) {
      (logoScrollContainer as HTMLElement).style.setProperty(
        logoCount,
        contentBlockProps?.logoImages?.length.toString() ?? '',
      );
      (logoScrollContainer as HTMLElement).style.setProperty(logoHeight, `${defaultLogoHeight.toString()}px`);
      (logoScrollContainer as HTMLElement).style.setProperty(logoWidth, `${defaultLogoWidth.toString()}px`);
    }
  }, [contentBlockProps?.logoImages?.length]);

  if (!contentBlockProps) {
    return null;
  }

  // I don't why TS is complaining about data.companyUrl, it's fine
  // Maybe it has something to do with the field being a URL in WP
  // TODO: look into this later

  return (
    <section
      className={style.logoScrollContainer}
      id={contentBlockProps.sectionId ?? undefined}
    >
      <Heading3
        className={style.title}
        fontSize={20}
      >
        {contentBlockProps.title}
      </Heading3>

      <div className={style.logoScrollLogoContainer}>
        {contentBlockProps.logoImages?.map(data => {
          if (data?.companyUrl) {
            return (
              <div
                className={style.logoContainer}
                key={`${data.companyUrl}-1`}
              >
                <Link
                  className={style.logoScrollLink}
                  href={data.companyUrl}
                >
                  {data.image && (
                    <AppImage
                      className={style.logoImage}
                      fallbackHeight={defaultLogoHeight}
                      fallbackWidth={defaultLogoWidth}
                      image={data.image}
                    />
                  )}
                </Link>
              </div>
            );
          }
        })}

        {/* repeat the list so we have enough items to keep the animation smooth */}
        {contentBlockProps.logoImages?.map(data => {
          if (data?.companyUrl) {
            return (
              <div
                className={style.logoContainer}
                key={`${data.companyUrl}-2`}
              >
                <Link
                  className={style.logoScrollLink}
                  href={data.companyUrl}
                >
                  {data.image && (
                    <AppImage
                      className={style.logoImage}
                      fallbackHeight={defaultLogoHeight}
                      fallbackWidth={defaultLogoWidth}
                      image={data.image}
                    />
                  )}
                </Link>
              </div>
            );
          }
        })}

        {/* repeat the list so we have enough items to keep the animation smooth */}
        {contentBlockProps.logoImages?.map(data => {
          if (data?.companyUrl) {
            return (
              <div
                className={style.logoContainer}
                key={`${data.companyUrl}-3`}
              >
                <Link
                  className={style.logoScrollLink}
                  href={data.companyUrl}
                >
                  {data.image && (
                    <AppImage
                      className={style.logoImage}
                      fallbackHeight={defaultLogoHeight}
                      fallbackWidth={defaultLogoWidth}
                      image={data.image}
                    />
                  )}
                </Link>
              </div>
            );
          }
        })}
      </div>
    </section>
  );
};

export default LogoScroll;
